import React from "react";
// ANT DESIGN COMPONENTS
import { Button } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useDispatch } from "react-redux";
import { updateOpenFormIconDefinition, updateOpenFormIconDefinitionAction } from "../../../redux/tools/toolsSlice";

function PermissionsHeader() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const dispatch = useDispatch();
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const handleOpenForm = () => {
		dispatch(updateOpenFormIconDefinition(true));
		dispatch(updateOpenFormIconDefinitionAction("create"));
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className='generalStyles__pageHeader'>
			<div className='generalStyles__mlFix mt-1'>
				<Button
					type='primary'
					icon={<FontAwesomeIcon icon={faPlus} className='generalStyles__mrFix' />}
					onClick={handleOpenForm}
				>
					{t("general.newPermission")}
				</Button>
			</div>
		</div>
	);
}

export default PermissionsHeader;
